<template>
  <div>
    <div>
      <div v-if="shipment.shouldUseProxy">
        <small class="text-success">
          <i class="fa fa-check" />
          Enabled
        </small>
      </div>
      <div v-else>
        <small class="text-muted">
          <i class="fa fa-info" />
          Disabled
        </small>
      </div>
    </div>
    <div v-if="shipment.forwardedToServicePoint">
      <div>
        <small class="text-secondary">Forwarded to SP</small>
      </div>
      <div v-if="!shipment.servicePoints?.length">
        <small class="text-danger">
          <i class="fa fa-warning" />
          SP not available
        </small>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { Shipment } from '@/types/Models/Shipment'
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'ProxyCell',
  props: {
    shipment: {
      type: Object as PropType<Shipment>,
      required: true,
    },
  },
})
</script>
